
    <article class="streaks-card">
        <div class="streaks-card-content">
            <a href="https://help.teammood.com/en/articles/6701896-about-bad-mood-streaks" target="_blank" class="streak-help-link"><i class="fa-solid fa-circle-question"></i></a>
            <h4>{{ 'bad-mood-streak.title' | translate}}</h4>
            <p class="streak-text mb-3">{{ 'bad-mood-streak.description' | translate}}</p>
        </div>
    </article>
       